import React, { useEffect, useRef, useState } from "react";
import { faAngleLeft, faBan, faEllipsisV, faFilePdf, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown } from "reactstrap";
import { useReactToPrint } from "react-to-print";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

//API
import infracoes_api from "../../../api/infracoes_api";
import analiseInfracao_api from "../../../api/analiseInfracao_api";
import funcionalidades_api from "../../../api/funcionalidades_api";

//Helpers
import { showMessage } from "../../../helpers/message";
import { objCampo, validarCampos } from "../../../helpers/ValidadorDeCampos";
import { openBase64File } from "../../../helpers/downloadFile";

//Context
import { useAuth } from "../../../context/auth";

//Constants
import { actionsTable } from "../../../constants/MaterialTable";

//Components
import AcoesRealizadas from "./components/AcoesRealizadas";
import AcoesPendentes from "./components/AcoesPendentes";
import CabecalhoInfracao from "./components/CabecalhoInfracao";
import DocumentoPersonalizado from "./components/DocumentoPersonalizado";
import TabelaListagem from "../../../components/TabelaListagem/TabelaListagem";
import ModalCustomized from "../../../components/Modal/Modal";
import CertificadoEntregaComunicacaoEletronica from "./components/CertificadoEntregaComunicacaoEletronica";
import ModalInfracaoCancelamento from "./components/ModalInfracaoCancelamento";
import ResertInfracao from "./components/ResertInfracao";
import Loading from "../../../components/Loading/Loading";
import ModalModeloImpressao from "./components/ModalModeloImpressao";
import ModalDocumentosSeparados from "./components/ModalDocumentosSeparados";

//Estilo da pagina de impressão
const pageStyle = `
@page { 
  size: auto;  
  margin: 0mm ; 
} 
@media print { 
    body { -webkit-print-color-adjust: exact; } 
}
@media print {
  @page{
    size:A4;
    margin:0;
  }
  .relatorio {
    width: 100vw!important;
    display:flex;
    flex-direction:column;
  }
  div.header{
    display:table-header-group;
  }
  div.body{
    display:table-row-group;
  }
  .noPrint{
    display: none;
  }

  .footer {
    display: none; /* Oculte o rodapé por padrão */
  }

  .page:last-child .footer {
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    padding: 5mm;
    border-top: 1px solid #ccc;
  }
}
`;

function FichaInfracao({ fichaExterna, historico = false, impressaoPDFDividaAtiva = null, preview = false, onCarregado = null }) {
  const { setLoading, session, loading } = useAuth();

  //State para lista de infração
  const [infracao, setInfracao] = useState(null);

  const avisouCarregado = useRef(false);

  useEffect(() => {
    if (!onCarregado || avisouCarregado.current || loading || !infracao)
      return;

    avisouCarregado.current = true;
    onCarregado();
  }, [loading, infracao, onCarregado]);

  //State para pegar as ações pendentes
  const [acoesPendentes, setAcoesPendentes] = useState([]);

  //State para visualizar o documento
  const [documento, setDocumento] = useState(null);

  //Estado de controle de exibição das ações realizadas
  const [showDivs, setShowDivs] = useState(impressaoPDFDividaAtiva ? true : false);

  //Estado de navegação
  const navigate = useNavigate();

  //Estado que pega os dados passados via navegação
  const location = useLocation();

  //State para controlar se poder cancelar ou não a infração
  const [cancelarInfracao, setCancelarinfracao] = useState(false);

  //Estado que guarda o objeto de envio dos dados da finalização
  const [infracaoCancelamento, setInfracaoCancelamento] = useState({
    fiscalizacaoInfracao_Id: "",
    justificativaCancelamento: ""
  });

  //pegando a etapa selecionada no dashboard
  const { infracao_id, originPath, stackRoutes } = location.state
    ? location.state
    : {};

  //Referencia para o componente de impressão
  const ref = useRef(null);

  //Estado para controlar visibilidade de abri ou fecha modal
  const [isOpenModal, setIsOpenModal] = useState(false);

  const [dadosExtracao, setDadosExtracao] = useState("");

  const toggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  const [isOpenModalResertInfracao, setIsOpenModalResertInfracao] = useState(false)
  const [isOpenModalImpressao, setIsOpenModalImpressao] = useState(false);
  const [isOpenModalDocumentosSeparados, setIsOpenModalDocumentosSeparados] = useState(false);

  //State com os itens de impressão parametrizados na etapa atual (completa + separados)
  const [itensImpressao, setItensImpressao] = useState({ possuiImpressaoCompleta: false, documentosSeparados: [] });

  //Controle de loading individual por botão de impressão separada em Pdf (evita travar a tela toda)

  const [infracaoAlteracaoEmail, setInfracaoAlteracaoEmail] = useState({
    emailAnterior: '',
    emailAtualizado: '',
    infratorId: '',
    fiscalizacaoInfracao_Id: ""
  });

  const campos = [
    objCampo({ name: "emailAtualizado", required: true })
  ];
  const [errors, setErrors] = useState({});

  function getMotivoRejeicao(motivo) {
    if (!motivo) return "";

    let jsonData = {};

    try {
      jsonData = JSON.parse(motivo);
    } catch (e) {
      return "Erro ao ler JSON";
    }

    if (jsonData?.bounce?.bounceType) {
      return jsonData?.bounce.bounceType;
    }

    if (jsonData?.bounce?.bouncedRecipients?.[0]?.diagnosticCode) {
      return jsonData?.bounce.bouncedRecipients[0].diagnosticCode;
    }

    if (jsonData?.complaint?.complaintSubType) {
      return jsonData?.complaint.complaintSubType;
    }

    if (jsonData?.complaint?.complaintFeedbackType) {
      return jsonData?.complaint.complaintFeedbackType;
    }

    return "";
  }


  const headersListaNotificacoesEmails = [
    {
      value: "Data/Hora Envio",
      objectValue: "dataHoraEnvio",
      formatDate: true,
      align: "left",
    },
    {
      value: "Data/Hora Recebimento",
      objectValue: "dataHoraRecebimento",
      formatDate: true,
      align: "left",
    },
    {
      value: "Descrição da Ação",
      objectValue: "acao",
      formatDate: true,
      align: "left",
    },
    {
      value: "Status",
      objectValue: "status",
      formatDate: true,
      align: "left",
    },
    {
      value: "E-mail",
      objectValue: "email",
      formatDate: true,
      align: "left",
    },
    {
      value: "Motivo Rejeição",
      objectValue: "motivoRejeicao",
      align: "left",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const notificacaoJson = infracao?.notificacoesEmails[dataIndex]?.json;
          return <>{getMotivoRejeicao(notificacaoJson)}</>;
        }
      }
    }
  ];

  const reenviarEmail = async () => {
    try {
      setLoading(true);
      await analiseInfracao_api.ReenviarEmailInfracao(infracao.id);
      return showMessage("Sucesso", "E-mail reenviado com sucesso.", "success", () => { loadInfracao() });
    }
    catch (erro) {
      showMessage('Erro', erro?.message ?? 'falha na requisição', "error", null);
    }
    finally {
      setLoading(false);
    }
  }

  const visualizar = (rowData) => {
    setDadosExtracao(rowData);
    toggleModal();
  };

  const loadAcoesPendentes = async () => {
    const idInfracaoFinal = infracao?.id ?? infracao_id ?? impressaoPDFDividaAtiva?.infracao_id;

    if (!!idInfracaoFinal) {
      try {
        setLoading(true);
        const response = await analiseInfracao_api.getListAcoesInternas(idInfracaoFinal);
        setAcoesPendentes(response.data);
      } catch (error) {
        showMessage("aviso", error?.message ?? "Erro na operação.", "error", null);
      } finally {
        setLoading(false);
      }
    }
  };


  const loadInfracaoItem = async () => {
    if (!!fichaExterna) {
      try {
        setLoading(true);
        const response = await infracoes_api.GetItemFiscalizacaoHash(fichaExterna.hash);

        let _infracoes = {
          ...response.data,
          notificacoesEmails: response.data.notificacoesEmails?.map((email) => ({
            ...email,
            dataHoraEnvio: email.dataHoraEnvio
              ? moment(email.dataHoraEnvio).format("DD/MM/YYYY HH:mm")
              : null,
            dataHoraRecebimento: email.dataHoraRecebimento
              ? moment(email.dataHoraRecebimento).format("DD/MM/YYYY HH:mm")
              : null,
          })),
        };

        setInfracao(_infracoes);
      } catch (error) {
        showMessage("aviso", error?.message ?? "Erro na operação.", "error", null);
      } finally {
        setLoading(false);
      }
    } else {
      const idInfracaoFinal =
        infracao?.id ?? infracao_id ?? impressaoPDFDividaAtiva?.infracao_id;

      if (!!idInfracaoFinal) {
        try {
          setLoading(true);
          const response = await infracoes_api.GetItemFiscalizacaoInfracao(idInfracaoFinal);

          let _infracoes = {
            ...response.data,
            notificacoesEmails: response.data.notificacoesEmails?.map((email) => ({
              ...email,
              dataHoraEnvio: email.dataHoraEnvio
                ? moment(email.dataHoraEnvio).format("DD/MM/YYYY HH:mm")
                : null,
              dataHoraRecebimento: email.dataHoraRecebimento
                ? moment(email.dataHoraRecebimento).format("DD/MM/YYYY HH:mm")
                : null,
            })),
          };

          setInfracao(_infracoes);
        } catch (error) {
          showMessage("aviso", error?.message ?? "Erro na operação.", "error", null);
        } finally {
          setLoading(false);
        }
      }
    }
  };


  const loadCancelarInfracao = async () => {
    try {
      setLoading(true);
      const response = await funcionalidades_api.ValidadarAcessoFuncionalidade("Cancelar.Infracao");
      setCancelarinfracao(response.data);
    } catch (error) {
      showMessage("aviso", error?.message ?? "Erro na operação.", "error", null);
    } finally {
      setLoading(false);
    }
  };

  const loadItensImpressao = async () => {
    const hash = infracao?.hash;

    if (!hash) return;

    try {
      const response = await infracoes_api.GetImpressaoItensDisponiveis(hash);
      setItensImpressao({
        possuiImpressaoCompleta: response.data?.possuiImpressaoCompleta ?? false,
        documentosSeparados: response.data?.documentosSeparados ?? [],
      });
    } catch (error) {
      // Parametrização de impressão é aditiva — falha aqui não deve travar a ficha
      setItensImpressao({ possuiImpressaoCompleta: false, documentosSeparados: [] });
    }
  };

  // Abre a prévia da Impressão Completa numa aba própria — a tela renderiza todos os itens
  // parametrizados na etapa em sequência, com um botão Imprimir (ver FichaImpressaoCompleta).
  const handleImpressaoCompleta = () => {
    window.open(`/empty/FichaImpressaoCompleta?hash=${infracao?.hash}`, "_blank");
  };

  // Todo item de impressão separada abre na FichaImpressaoSeparada, que resolve o item pelo hash e
  // escolhe o visualizador pelo formato — inclusive Pdf, que antes baixava como blob e virava modal
  // de erro quando o documento não tinha anexo na infração (a tela agora mostra o aviso inline).
  // Ficha de Infração e de Fiscalização seguem nas telas dedicadas: imprimem a partir de hashes
  // próprios que a tela separada não recebe.
  const handleImpressaoDocumentoSeparado = (item) => {
    if (item.tipoItem === "FichaInfracao") {
      window.open(`/empty/ImpressaoFichaInfracaoCompleta?hash=${infracao?.hash}`, "_blank");
      return;
    }

    if (item.tipoItem === "FichaFiscalizacao") {
      window.open(`/empty/ImpressaoFichaFiscalizacaoCompleta?hash=${infracao?.hashFiscalizacao}`, "_blank");
      return;
    }

    window.open(`/empty/FichaImpressaoSeparada?hash=${infracao?.hash}&parametrizacaoHash=${item.hash}`, "_blank");
  };

  const loadAcoesPendentesHash = async () => {
    try {
      setLoading(true);
      const response = await analiseInfracao_api.getListAcoesExternas(
        infracao?.hash ?? fichaExterna?.hash
      );
      setAcoesPendentes(response.data);
    } catch (error) {
      showMessage("aviso", error?.message ?? "Erro na operação", "error", null);
    } finally {
      setLoading(false);
    }
  };


  const loadInfracao = async () => {
    // Em modo prévia (infração ainda não gravada), não buscar dados nem carregar ações
    if (preview && fichaExterna) {
      setInfracao(fichaExterna);
      return;
    }

    // Em modo histórico, não buscar dados nem carregar ações
    if (historico && fichaExterna) {
      setInfracao(fichaExterna);
      return;
    }

    if (!fichaExterna && session != null) {
      await loadAcoesPendentes();
      await loadInfracaoItem();
      await loadCancelarInfracao();
    }
    if (fichaExterna && session == null) {
      setInfracao(fichaExterna);
      await loadAcoesPendentesHash();
    }
  };

  //Função assionada assim que o botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
    content: () => ref.current,
    copyStyles: true,
    documentTitle: "Auto de Infração_" + infracao?.numeroInfracao,
    pageStyle: pageStyle,
    onAfterPrint: () => {
      setShowDivs(false);
    },
  });

  const handleVisualizarFiscalizacao = (fiscalizacao) => {
    if (!fichaExterna)
      navigate("/admin/ficha-fiscalizacao", {
        state: {
          ...location.state,
          fiscalizacao_id: fiscalizacao.fiscalizacao_Id,
          numeroInfracao: infracao?.numeroInfracao,
          stackRoutes: [...(stackRoutes ?? []), infracao_id],
          btnVoltar: "/admin/ficha-infracao",
        },
      });
    else
      navigate(
        `/auth/consultaFiscalizacaoMunicipe?hash=${fiscalizacao.hashFiscalizacao}`
      );
  };

  const handleConsultaBoleto = () => {
    setLoading(true);
    analiseInfracao_api
      .GetSolicitarBoleto(infracao?.id)
      .then((response) => {
        if (response.data && !!response.data.arquivo) {
          openBase64File(response.data.arquivo);
          setTimeout(() => {
            loadInfracao();
          }, 200);
        }
      })
      .catch((error) => showMessage("aviso", error.message, "error", null))
      .finally(() => setLoading(false));
  };

  const onSubmitAlteracaoEmail = async () => {
    try {
      setLoading(true);

      const _infracaoAlteracaoEmail = { ...infracaoAlteracaoEmail };
      const _errorsInfracaoAlteracaoEmail = validarCampos(_infracaoAlteracaoEmail, campos);
      setErrors(_errorsInfracaoAlteracaoEmail[0]);
      if (_errorsInfracaoAlteracaoEmail[1].length > 0)
        return;

      await infracoes_api.PutAlteracaoEmail(_infracaoAlteracaoEmail);
      return showMessage("Sucesso", "Email atualizado com sucesso!", "success", () => { loadInfracao() });
    }
    catch (erro) {
      showMessage('Erro', erro?.message ?? 'falha na requisição', "error", null);
    }
    finally {
      setLoading(false);
    }
  }



  //Deps intencionalmente restritas ao que identifica a infração e a sessão: incluir a função e os
  //flags recriaria a consulta a cada render, como nos demais efeitos desta tela.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!!infracao && session != null && !impressaoPDFDividaAtiva && !historico) {
      loadItensImpressao();
    }
  }, [infracao?.id, infracao?.hash, session?.id]);

  useEffect(() => {
    if (!!infracao) {
      setInfracaoAlteracaoEmail({
        emailAnterior: infracao?.infrator?.email ?? '',
        emailAtualizado: '',
        infratorId: infracao?.infrator?.id ?? '',
        fiscalizacaoInfracao_Id: infracao.id,
      });
    }
  }, [infracao]);

  useEffect(() => {
    loadInfracao();
  }, [infracao_id]);

  if (loading || !infracao) return <Loading />

  return (
    <>
      {!documento && (
        <div style={{ color: "#666" }}>
          {!impressaoPDFDividaAtiva && !preview &&
            <div className="d-flex justify-content-between align-items-center mb-3">
              <ModalCustomized
                toggle={toggleModal}
                isOpen={isOpenModal}
                btnClose={toggleModal}
                title={""}
              >
                <CertificadoEntregaComunicacaoEletronica
                  dadosExtracao={dadosExtracao}
                  dadosInfracao={infracao}
                />
              </ModalCustomized>

              <ModalInfracaoCancelamento
                infracaoCancelamento={infracaoCancelamento}
                setInfracaoCancelamento={setInfracaoCancelamento}
              />

              {!!infracao &&
                <ResertInfracao
                  loadInfracao={loadInfracao}
                  infracao={infracao}
                  isOpenModal={isOpenModalResertInfracao}
                  handleCloseModal={() => setIsOpenModalResertInfracao(false)}
                />
              }

              {session != null && (
                <Button
                  onClick={() => {
                    if (
                      !fichaExterna &&
                      (!stackRoutes || stackRoutes.length == 0)
                    )
                      navigate(originPath, { state: { ...location.state } });
                    else if (stackRoutes) {
                      if (
                        stackRoutes.length == 1 &&
                        stackRoutes[0] == infracao_id
                      )
                        navigate(originPath, { state: { ...location.state } });
                      else
                        navigate("/admin/ficha-fiscalizacao", {
                          state: {
                            ...location.state,
                            stackRoutes: stackRoutes.filter(
                              (v) => v != infracao_id
                            ),
                          },
                        });
                    } else navigate(-1);
                  }}
                >
                  <FontAwesomeIcon icon={faAngleLeft} /> Voltar
                </Button>
              )}
              <div className="d-flex gap-2">
                <Button
                  color="danger"
                  onClick={() => {
                    if (session != null) {
                      setIsOpenModalImpressao(true);
                    } else {
                      setShowDivs(true);
                      setTimeout(() => {
                        handlePrint();
                      }, 500);
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faFilePdf} /> Imprimir
                </Button>

                {session != null && itensImpressao.possuiImpressaoCompleta && (
                  <Button
                    color="primary"
                    onClick={handleImpressaoCompleta}
                  >
                    <FontAwesomeIcon icon={faFilePdf} /> Impressão Completa
                  </Button>
                )}

                {session != null && itensImpressao.documentosSeparados.length === 1 && (
                  <Button
                    color="secondary"
                    onClick={() => handleImpressaoDocumentoSeparado(itensImpressao.documentosSeparados[0])}
                  >
                    <FontAwesomeIcon icon={faFilePdf} />{" "}
                    {itensImpressao.documentosSeparados[0].identificacao}
                  </Button>
                )}

                {session != null && itensImpressao.documentosSeparados.length > 1 && (
                  <Button
                    color="secondary"
                    onClick={() => setIsOpenModalDocumentosSeparados(true)}
                  >
                    <FontAwesomeIcon icon={faFilePdf} /> Documentos
                  </Button>
                )}
              </div>
            </div>
          }
          {/* Modal de Documentos Separados */}
          <ModalDocumentosSeparados
            isOpen={isOpenModalDocumentosSeparados}
            toggle={() => setIsOpenModalDocumentosSeparados(false)}
            itens={itensImpressao.documentosSeparados}
            onSelecionar={(item) => {
              setIsOpenModalDocumentosSeparados(false);
              handleImpressaoDocumentoSeparado(item);
            }}
          />
          {/* Modal de Impressao */}
          <ModalModeloImpressao
            isOpen={isOpenModalImpressao}
            toggle={() => setIsOpenModalImpressao(false)}
            handlePrintSimplificada={() => {
              setIsOpenModalImpressao(false);
              setShowDivs(true);
              setTimeout(() => {
                handlePrint();
              }, 500);
            }}
            handlePrintCompleta={() => {
              setIsOpenModalImpressao(false);
              const url = `/empty/ImpressaoFichaInfracaoCompleta?hash=${infracao?.hash ?? fichaExterna?.hash}`;
              window.open(url, "_blank", "noopener,noreferrer");
            }}
          />
          <div
            className={`bg-white p-3 rounded shadowFicha mainContainerFicha documentoImpressao `}
            ref={ref}
          >
            <CabecalhoInfracao
              infracao={infracao}
              handleVisualizarFiscalizacao={handleVisualizarFiscalizacao}
              visualizar={session != null}
              loadInfracao={loadInfracao}
              onSubmitAlteracaoEmail={onSubmitAlteracaoEmail}
              infracaoAlteracaoEmail={infracaoAlteracaoEmail}
              setInfracaoAlteracaoEmail={setInfracaoAlteracaoEmail}
              reenviarEmail={reenviarEmail}
              showDivs={showDivs}
              historico={historico}
              preview={preview}
            />
            {session && infracao?.notificacoesEmails?.length > 0 && (
              <div className="mt-4 shadowFicha rounded-3">
                <h5 className="p-2 titleFicha">Notificação via E-mail</h5>
                <Row className="px-3 py-2">
                  <Col md="12" className="mb-2">
                    <TabelaListagem
                      actions={!historico ? [
                        (rowData) => {
                          if (!!rowData.dataHoraRecebimento && rowData.status !== "Rejeitado") {
                            return actionsTable.imprimir(visualizar);
                          } else return null;
                        },
                      ] : []}
                      headers={headersListaNotificacoesEmails}
                      items={infracao?.notificacoesEmails}
                    />
                  </Col>
                </Row>
              </div>
            )}

            {!preview && (
            <div className=" mt-4 shadowFicha historico rounded-3">
              <h5 className="p-2 titleFicha">Historico de eventos</h5>
              {!showDivs && (
                <div className="noPrint px-3 py-1 d-flex justify-content-end align-items-center gap-3">
                  {!historico && infracao &&
                    infracao.cancelada === false &&
                    (infracao.possuiDividaAtiva == false && infracao?.boletos?.length > 0) &&
                    //Logado: respeita a emissão pelo Gestor na etapa; acesso público (sem sessão): respeita a emissão pelo Infrator
                    (session != null ? infracao?.permiteBoletoGestor !== false : infracao?.permiteBoletoInfrator !== false) &&
                    //Aberto a partir da tela de Dívida Ativa: não deve permitir emissão/envio de boleto
                    originPath !== "/admin/inscricaoDividaAtiva" && (
                      <Button
                        color={
                          infracao?.boletos?.some(
                            (x) => x.status == "Liquidado"
                          )
                            ? "success"
                            : "danger"
                        }
                        onClick={handleConsultaBoleto}
                      >
                        <FontAwesomeIcon icon={faFilePdf} />{" "}
                        {infracao?.boletos?.some((x) => x.status == "Liquidado")
                          ? "Boleto Liquidado"
                          : "Boleto"}
                      </Button>
                    )}

                  {session &&
                    !historico &&
                    infracao &&
                    <UncontrolledDropdown>
                      <DropdownToggle color="secondary">
                        <FontAwesomeIcon icon={faEllipsisV} />
                      </DropdownToggle>
                      <DropdownMenu>
                        {infracao.cancelada === false &&
                          infracao.analiseFinalizada != true &&
                          infracao.possuiDividaAtiva == false &&
                          cancelarInfracao && (
                            <DropdownItem
                              onClick={() => {
                                setInfracaoCancelamento({
                                  ...infracaoCancelamento,
                                  fiscalizacaoInfracao_Id: infracao.id,
                                })
                              }}
                            >
                              <FontAwesomeIcon icon={faBan} className="me-2" />
                              Cancelar Infração
                            </DropdownItem>
                          )}

                        {infracao.resertaInfracao == true &&
                          <DropdownItem onClick={() => setIsOpenModalResertInfracao(true)}>
                            <FontAwesomeIcon icon={faRotateLeft} className="me-2" />
                            Resetar Infração
                          </DropdownItem>
                        }
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  }
                </div>
              )}
              <Row className="p-3">
                <Col
                  md="0"
                  lg="1"
                  className="d-flex align-items-start justify-content-end"
                >
                  <div
                    className="bg-secondary h-100 d-lg-block d-md-none"
                    style={{ width: "3px" }}
                  ></div>
                </Col>
                <Col md="12" lg="11">
                  <AcoesRealizadas
                    acoes={infracao?.acoes}
                    showDivs={showDivs}
                    infracao={infracao}
                    impressaoPDFDividaAtiva={impressaoPDFDividaAtiva}
                  />
                  {infracao &&
                    !historico &&
                    infracao.cancelada != true &&
                    <AcoesPendentes
                      infracao={infracao}
                      acoesPendentes={acoesPendentes}
                      loadInfracaoItem={loadInfracaoItem}
                      loadAcoesPendentes={() => {
                        if (fichaExterna != null) loadAcoesPendentesHash();
                        else loadAcoesPendentes();
                      }}
                      setDocumento={setDocumento}
                    />}
                </Col>
              </Row>
            </div>
            )}

            <div className="rodapeDocumento">
              <div className="print m-2 d-flex align-items-center justify-content-between">
                <p>Auto de Infração e Sanção: {infracao?.numeroInfracao}</p>
                <p>
                  documento original extraído do sistema FiscSP, em{" "}
                  {moment().format("DD/MM/YYYY")}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {documento && (
        <DocumentoPersonalizado
          documento={documento}
          handleVoltar={() => setDocumento(null)}
        />
      )}
    </>
  );
}

export default FichaInfracao;
